import Vue from 'vue'

Vue.filter('dateFormatText', (string) => {
  const dateObj = new Date(string)
  return new Intl.DateTimeFormat('fr-CA', {
    dateStyle: 'full',
  }).format(dateObj)
})
